/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './PrimaryButton.style';

import BaseButton from 'src/shared/ui/component/button/BaseButton';
import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

import type { Button } from '@e180/ui/lib/component/button/type/buttonTypes';

type Props = Button & {
  fitText: ?boolean,
  stopPropagation: ?boolean,
  withSuccess: ?boolean,
  children: ?string,
};

const useStyles = createUseStyles(styles);

const PrimaryButton = ({
  layoutClass,
  href,
  handleClick,
  handleMouseOver,
  isDisabled,
  isSubmitting,
  isFetching,
  large,
  fitText,
  stopPropagation,
  withSuccess,
  hasFocus,
  children,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor, darkAccentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ darkAccentColor, accentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-withSuccess']]: withSuccess,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <BaseButton
      className={rootClasses}
      layoutClass
      href={href}
      handleClick={handleClick}
      handleMouseOver={handleMouseOver}
      isDisabled={isDisabled}
      isSubmitting={isSubmitting}
      isFetching={isFetching}
      large={large}
      fitText={fitText}
      stopPropagation={stopPropagation}
      withSuccess={withSuccess}
      hasFocus={hasFocus}
    >
      {children}
    </BaseButton>
  );
};

export default compose(React.memo)(PrimaryButton);
